import submitted from "./order/submitted";
import submit from "./order/submit";

export default {
    submit,
    submitted
}